import { render, staticRenderFns } from "./ViewIssuedTickets.vue?vue&type=template&id=bddd3942"
import script from "./ViewIssuedTickets.vue?vue&type=script&lang=js"
export * from "./ViewIssuedTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports